import { Component, Vue } from 'vue-property-decorator';

import { HeroArticleBlockViewModel } from './HeroArticleModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import PhotographyInfoComponent from '@/components/PhotographyInfoComponent/PhotographyInfoComponent.vue';
import ImageVideoGallery from '@/components/ImageVideoGallery/ImageVideoGallery.vue';

import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import ContentCategory from '@/common/interfaces/enums/ContentCategory';
import ContentType from '@/common/interfaces/enums/ContentType';

import Listen from '@/assets/icons/listen.svg?inline';
import Watch from '@/assets/icons/watch.svg?inline';
import Read from '@/assets/icons/read2.svg?inline';
import Wildlife from '@/assets/icons/binoculars.svg?inline';
import DER from '@/assets/icons/article.svg?inline';
import WorldView from '@/assets/icons/globe.svg?inline';
import Culture from '@/assets/icons/culture.svg?inline';
import Video360 from '@/assets/icons/binoculars.svg?inline';
import Calendar from '@/assets/icons/calendar.svg?inline';
import Rectangles from '@/assets/icons/rectangles.svg?inline';

import { getResizeImage } from '@/utils/commonUtils';

const HeroArticleModuleProps = Vue.extend({
  props: getComponentProps<HeroArticleBlockViewModel>({
    Header: 'How the travel industry can help fight climate change',
    Image: { Url: getResizeImage('leopard.jpg'), Alt: 'Leopard' },
    Date: '16 JUN 2019',
    IsCreatedDateVisible: true,
    Category: ContentCategory.WildLife,
    Type: ContentType.Read,
    Minutes: 4,
    BackLink: '#',
    PhotographyInfo: {
      Photographer: {
        PhotographerName: 'Robert Swan',
        PhotographerTitle: 'Guest',
        PhotoDate: 'May 2018',
        PhotographerImage: {
          Url: getResizeImage('photographer.jpg'),
          Alt: 'Photographer',
        },
      },
      Exposure: {
        Speed: 'F/8',
        Aperture: '1/800',
        Iso: 'ISO 400',
      },
    },
    Gallery: {
      Slides: [
        {
          From: {
            Title: 'An Exciting Visit To Iceland',
            Link: '',
          },
          Image: {
            Url: getResizeImage('iceberg.jpg'),
            Alt: '',
          },
          Caption:
            "A whale narrates the first chapter of Piers Morgan's autobiography to a largely disinterested emperor penguin",
          Photographer: {
            PhotographerName: 'Dave Hasacamera',
            PhotographerTitle: 'Survivalist',
            PhotoDate: '15 June 2016',
            PhotographerImage: {
              Url: getResizeImage('moose.jpg'),
              Alt: 'Alt text for the photgrapher image',
            },
          },
        },
      ],
      ShareData: {
        Url: 'https://d3t9z7c45vc1rg.cloudfront.net/',
        Title: '10 Tips for Better Expedition Photos',
        Description:
          'Grosvenor Teacher Fellow Cristina Veresan shares the photo lessons she learned while on expedition in Svalbard.',
        Hashtags: 'article,travel,lindblad',
        Quote: 'Lindblad article - facebook',
        TwitterUser: 'LindbladExp',
      },
    },
  }),
});

@Component({
  components: {
    ResponsiveImage,
    ImageVideoGallery,
    PhotographyInfo: PhotographyInfoComponent,
    Listen,
    Watch,
    Read,
    Video360,
    Wildlife,
    DER,
    WorldView,
    Culture,
    Calendar,
    Rectangles,
  },
})
export default class HeroArticleModule extends HeroArticleModuleProps {
  imageSizes: ImageSizes = {
    def: new ImageSize([1920, 1080]),
    sizes: {
      sm: new ImageSize([768, 1024]),
      md: new ImageSize([992, 744]),
      lg: new ImageSize([1199, 900]),
      xl: new ImageSize([1920, 1080]),
    },
  };

  get Type() {
    switch (this.p.Type) {
      case ContentType.Read:
        return 'Read';
      case ContentType.Watch:
        return 'Watch';
      case ContentType.Listen:
        return 'Listen';
      case ContentType.Video360:
        return 'Video360';
    }
  }

  get Category() {
    switch (this.p.Category) {
      case ContentCategory.WildLife:
        return 'Wildlife';
      case ContentCategory.WorldView:
        return 'WorldView';
      case ContentCategory.Culture:
        return 'Culture';
      case ContentCategory.DER:
        return 'DER';
    }
  }

  get ShareData() {
    return this.p.Gallery.ShareData || {};
  }
}
